import * as React from 'react';
import * as styles from './Checkout.css';
import { AuctionContainer, CalltrackingContainer, ServiceContainer, SubscriptionContainer } from './components';

export const Checkout = () => {
  return (
    <div className={styles['wrapper']}>
      <ServiceContainer />
      <SubscriptionContainer />
      <AuctionContainer />
      <CalltrackingContainer />
    </div>
  );
};
